var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"text":_vm.text,"color":_vm.buttonColor},on:{"click":function($event){return _vm.like()}}},[_c('v-icon',{staticClass:"mr-2",class:_vm.getColor,staticStyle:{"font-size":"21px"}},[_vm._v("\n      $vuetify.icons.mdiHeart\n    ")]),_vm._v(" "),_c('span',{class:_vm.getColor},[_vm._v(_vm._s(_vm.transLikeText))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }